<template>
  <div>
    <PreLoader v-if="isLoading" />

    <CustomBottomSheet
      refName="ProductAdd"
      size="xl"
      :headerText="$t('Products.add')"
      :headerIcon="product.icon"
      :clickToClose="false"
      :swipeAble="false"
      @opened="product.setInitialValue()"
    >
      <ProductForm
        v-if="!isLoading"
        id="add"
        :product="product"
        v-on:submitForm="addProduct()"
        bottomSheetName="ProductAdd"
        :submitName="$t('add')"
      />
    </CustomBottomSheet>
    <ConfirmClearData
      dialogName="ProductAdd"
      v-on:response="response($event)"
    />
  </div>
</template>

<script>
import PreLoader from "./../../../../../components/general/PreLoader.vue";
import CustomBottomSheet from "./../../../../../components/general/CustomBottomSheet.vue";
import ConfirmClearData from "./../../../../../components/general/ConfirmClearData.vue";
import ProductForm from "./ProductForm.vue";
import { STATUS } from "./../../../../../utils/constants";
import { objectToFormData } from "./../../../../../utils/functions";
import apiProduct from "./../../../../../api/settings/settingsOthers/products";
import generalMixin from "./../../../../../utils/generalMixin";

export default {
  mixins: [generalMixin],
  components: {
    PreLoader,
    CustomBottomSheet,
    ConfirmClearData,
    ProductForm,
  },
  props: ["product"],
  methods: {
    async addProduct() {
      this.isLoading = true;
      let formData = objectToFormData(this.product);
      try {
        const response = await apiProduct.add(formData);
        if (response.data.status == STATUS.SUCCESS) {
          this.showMsg(response.data.msg, true);
          this.$bvModal.show("ConfirmClearData-ProductAdd");
        } else if (response.data.status == STATUS.INVALID_TOKEN) {
          this.$store.dispatch("logoutUser", response.data.msg);
          this.showMsg(response.data.msg);
        } else {
          this.showMsg(response.data.msg);
        }
      } catch (error) {
        this.showMsg(this.$t("errorCatch"));
      }
      this.isLoading = false;
    },
    response(data) {
      this.$emit("refresh");
      switch (data) {
        case "yes":
          this.product.setInitialValue();
          break;
        case "leave":
          this.product.setInitialValue();
          this.closeBottomSheet("ProductAdd");
          break;
      }
    },
  },
};
</script>
